up.compiler('input[type="checkbox"], input[type="radio"]', (element) => {
  const $element = $(element)
  if ($element.closest('.btn').length > 0) return

  let type = $element.attr('type')
  let cookieBotContainer = document.querySelector('#CybotCookiebotDialog')

  if (cookieBotContainer != null && cookieBotContainer.contains($element[0])) {
    // do not style this inputs
  } else {
    $element.addClass('custom-control-input')

    let $label = $element.closest('label')
    if ($label.length > 0) {
      $label.addClass('custom-control').addClass(`custom-${type}`)
    } else {
      $element.wrap(`<span class="custom-control custom-${type}" />`)
    }

    if (!$element.hasClass('hidden-checkbox')) {
      $('<span class="custom-control-indicator" />').insertAfter($element)
    }
  }
})
